<app-header-one [sticky]="false"></app-header-one>

<!-- Home slider start-->
<section class="p-0">
    <app-slider 
        [sliders]="sliders"
        [textClass]="'text-center'"
        [category]="'fashion'"
        [buttonText]="'shop now'">
    </app-slider>
</section>
<!-- Home slider End -->

<div class="row">
    <div style="margin-top: 2%; color: #0fb3db;" class="col-12 text-center home-spedizioni">
        <svg class="svg" xmlns="http://www.w3.org/2000/svg"  viewBox="0 -117 679.99892 679"><path d="m12.347656 378.382812h37.390625c4.371094 37.714844 36.316407 66.164063 74.277344 66.164063 37.96875 0 69.90625-28.449219 74.28125-66.164063h241.789063c4.382812 37.714844 36.316406 66.164063 74.277343 66.164063 37.96875 0 69.902344-28.449219 74.285157-66.164063h78.890624c6.882813 0 12.460938-5.578124 12.460938-12.460937v-352.957031c0-6.882813-5.578125-12.464844-12.460938-12.464844h-432.476562c-6.875 0-12.457031 5.582031-12.457031 12.464844v69.914062h-105.570313c-4.074218.011719-7.890625 2.007813-10.21875 5.363282l-68.171875 97.582031-26.667969 37.390625-9.722656 13.835937c-1.457031 2.082031-2.2421872 4.558594-2.24999975 7.101563v121.398437c-.09765625 3.34375 1.15624975 6.589844 3.47656275 9.003907 2.320312 2.417968 5.519531 3.796874 8.867187 3.828124zm111.417969 37.386719c-27.527344 0-49.851563-22.320312-49.851563-49.847656 0-27.535156 22.324219-49.855469 49.851563-49.855469 27.535156 0 49.855469 22.320313 49.855469 49.855469 0 27.632813-22.21875 50.132813-49.855469 50.472656zm390.347656 0c-27.53125 0-49.855469-22.320312-49.855469-49.847656 0-27.535156 22.324219-49.855469 49.855469-49.855469 27.539063 0 49.855469 22.320313 49.855469 49.855469.003906 27.632813-22.21875 50.132813-49.855469 50.472656zm140.710938-390.34375v223.34375h-338.375c-6.882813 0-12.464844 5.578125-12.464844 12.460938 0 6.882812 5.582031 12.464843 12.464844 12.464843h338.375v79.761719h-66.421875c-4.382813-37.710937-36.320313-66.15625-74.289063-66.15625-37.960937 0-69.898437 28.445313-74.277343 66.15625h-192.308594v-271.324219h89.980468c6.882813 0 12.464844-5.582031 12.464844-12.464843 0-6.882813-5.582031-12.464844-12.464844-12.464844h-89.980468v-31.777344zm-531.304688 82.382813h99.703125v245.648437h-24.925781c-4.375-37.710937-36.3125-66.15625-74.28125-66.15625-37.960937 0-69.90625 28.445313-74.277344 66.15625h-24.929687v-105.316406l3.738281-5.359375h152.054687c6.882813 0 12.460938-5.574219 12.460938-12.457031v-92.226563c0-6.882812-5.578125-12.464844-12.460938-12.464844h-69.796874zm-30.160156 43h74.777344v67.296875h-122.265625zm0 0" fill="#ff4c3b"/></svg>
        Spedizione gratuita in Italia per ordini pari o superiori a 89 euro
    </div>
</div>

<!-- collection banner start-->
<section class="banner-padding banner-furniture">
    <div class="container-fluid">
        <div class="row partition2">
            <div class="col-md-6" *ngFor="let collection of collections1">
                <a [routerLink]="collection.url" [queryParams]="collection.queryParams">
                    <div class="collection-banner p-left text-start">
                        <img [src]="collection.image" class="img-fluid" alt="collection-banner">
                        <div class="contain-banner">
                            <div>
                                <h4>{{collection.save}}</h4>
                                <h2 [ngStyle]="{left: collection.styles.left}" class="collection-titles" >{{collection.title}}</h2>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</section>

<!-- Tab product start-->
<div class="title1 section-t-space">
    <h4>Ultime novita'</h4>
    <h3 class="title-inner1 font-size-mobile">SCOPRI I NOSTRI PRODOTTI</h3>
</div>
<section class="section-b-space p-t-0">
    <div class="container">
        <div class="row">
            <div class="col theme-tab">
                <div class="row no-slider">
                    <ng-container *ngFor="let product of newProductCollection">
                        <div class="col-6 product-box">
                            <app-product-box-one [product]="product" [currency]="productService?.Currency">
                            </app-product-box-one>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Tab product End -->

<div class="row footer-image-only-mobile">
    <div class="col"></div>
    <div class="col-10">
        <img style="width: 100%;" src="web/assets/images/homepage/lower.jpg" alt="footer_image"/>
    </div>
    <div class="col"></div>
</div>

<!-- Parallax banner start-->
<section class="p-0 footer-image-only-desktop">
    <div class="full-banner parallax-banner1 parallax text-center p-left" [ngStyle]="{'background-image': 'url(web/assets/images/homepage/lower.jpg)'}">
        <div class="container">
            <div class="row">
                <div class="col" style="min-height: 150px;"></div>
            </div>
        </div>
    </div>
</section>
<!-- Parallax banner End -->

<app-footer-two [themeLogo]="themeLogo"></app-footer-two>